import { Box, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";

interface NavigationItem {
  label: string;
  link: string;
  icon: any;
}

export const socialMedia: NavigationItem[] = [
  {
    label: "facebook",
    link: "https://www.facebook.com/profile.php?id=100007719697371",
    icon: <FacebookIcon />,
  },
  {
    label: "linkedin",
    link: "https://www.linkedin.com/in/serhii-petrenko-787aa9152/?trk=uno-choose-ge-no-intent&dl=no",
    icon: <LinkedInIcon />,
  },
  {
    label: "Github",
    link: "https://github.com/PetrenkoSerhii",
    icon: <GitHubIcon />,
  },
  {
    label: "tweet",
    link: "https://x.com/SerhiiPetr7994",
    icon: <TwitterIcon />,
  },
];

export const Footer = () => {
  return (
    <Box
      sx={{
        height: "20vh",
        mt: {
          xs: "200px",
          sm: "150px",
          md: "0px",
        },
        paddingX: {
          xs: "40px",
          sm: "50px",
          md: "70px",
        },
      }}
    >
      <Box
        sx={{
         color: "var(--c-light-bg-color)",
          //height: "20px",
          width: "100%",
          backgroundColor: "var(--c-main-color-hover)",
          px: {
            xs: 1,
            sm: 5,
            md: 10,
          },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "5px",
          fontWeight: 600,
          fontSize: {
            xs: "12px",
            sm: "13px",
            md: "15px",
          },
        }}
      >
        {
          "Some of the personal information on this site is temporarily hidden due to the ongoing war in my beloved country."
        }
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", height: "20vh" }}>
        {socialMedia?.map((el) => (
          <Box
            sx={{
              display: "flex",
              flexBasis: "80px",
              justifyContent: "center",
              alignItems: "center",
              "& .MuiSvgIcon-root": {
               color: "var(--c-text-color)",
                width: 40,
                height: 40,
              },
            }}
          >
            <IconButton href={el?.link}>{el?.icon}</IconButton>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
